export default __webpack_public_path__ + "static/media/KOD0107-min.fb8d4ab0.webp";